import React from 'react'
import _cx from 'classnames/bind'
import cls from '../styles.scss'
import { enums } from '@adc/sdk'
import { utils as coreUtils } from '@adc/ui-core'
import { match } from 'ts-pattern'
import { ConfirmingBid, TpsConfirmingBid } from '../costs'
import type {
  Listing,
  OnlineAuctionSegment,
  LiveAuctionSegment,
  Maybe,
} from '@adc/sdk/types'
const cx = _cx.bind(cls)

const bidTypeToTextMap = {
  [enums.OnlineAuctionSegmentBidType.Regular]: 'Your Next Bid:',
  [enums.LiveAuctionSegmentBidType.RemoteBid]: 'Your Remote Bid:',
}

export type BidTypeKey = keyof typeof bidTypeToTextMap

type ContentProps = {
  bidAmount: number
  segment: OnlineAuctionSegment | LiveAuctionSegment
  buyersPremium: number
  totalPurchasePrice: number
  earnestMoneyDeposit: number
  usingSellerLevelFees?: Maybe<boolean>
  listing: Listing
  type: BidTypeKey
}

const Content = ({
  bidAmount,
  buyersPremium,
  totalPurchasePrice,
  earnestMoneyDeposit,
  usingSellerLevelFees,
  listing,
  segment,
  type,
}: ContentProps) => {
  const bidContent = (
    type: string,
    isForeclosure = false,
    isEnglish = false
  ) => {
    const props = {
      bidAmount,
      buyersPremium,
      totalPurchasePrice,
      earnestMoneyDeposit,
      segment,
      type,
    }
    return match({ type, isForeclosure, isEnglish })
      .with(
        {
          type: enums.OnlineAuctionSegmentBidType.Regular,
          isForeclosure: true,
        },
        { type: enums.LiveAuctionSegmentBidType.RemoteBid },
        () => (
          <TpsConfirmingBid
            {...props}
            salesDeposit={listing.trustee?.online_state_deposit_amount}
          />
        )
      )
      .with(
        {
          type: enums.OnlineAuctionSegmentBidType.Regular,
          isForeclosure: false,
        },
        () => <ConfirmingBid {...props} />
      )
      .otherwise(() => null)
  }
  return (
    <>
      <div className={cx('bid-pill-container')}>
        <div className={cx('bid-pill')} data-elm-id='amount_to_bid'>
          <span>{bidTypeToTextMap[type]}</span>
          <span>{coreUtils.formatters.formatMoney(bidAmount, {})}</span>
        </div>
      </div>
      {(usingSellerLevelFees ||
        type === enums.LiveAuctionSegmentBidType.RemoteBid) && (
        <div className={cx('u-mb-3')}>
          {bidContent(
            type,
            listing.listing_configuration?.asset_type ===
              enums.AssetType.Foreclosure,
            listing.online_auction_segment?.segment_type ===
              enums.OnlineAuctionSegmentType.English
          )}
        </div>
      )}
    </>
  )
}

export default Content
